import { agileScrumModule } from './modules/agile-fundamentals';
import { teamCollaborationModule } from './modules/team-collaboration';
import { scalingAgileModule } from './modules/scaling-agile';
import { metricsImprovementModule } from './modules/metrics-improvement';

export const agileScrumCourse = {
  id: 'agile-scrum-enterprise',
  title: 'Agile & Scrum for Enterprise Development',
  description: 'Agile methodologies, Scrum practices, and project management for enterprise teams',
  level: 'beginner',
  totalDuration: '12 hours',
  image: '/api/placeholder/400/300',
  prerequisites: ['Basic project experience'],
  learningOutcomes: [
    'Implement Agile and Scrum methodologies effectively',
    'Manage enterprise development projects and timelines',
    'Facilitate team collaboration and communication',
    'Measure and improve team productivity and delivery'
  ],
  modules: [
    { ...agileScrumModule, order: 1, estimatedTime: 60 },
    { ...teamCollaborationModule, order: 2, estimatedTime: 45 },
    { ...scalingAgileModule, order: 3, estimatedTime: 75 },
    { ...metricsImprovementModule, order: 4, estimatedTime: 60 }
  ]
};